var _path, _circle, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon2 = function SvgIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.25 17.692h-6.161v2.538h3.696v1.27H2.464v-1.27H6.16v-2.538H0V5h17.25zM7.391 20.23h2.464v-2.538H7.392zM16.017 6.27H1.23v10.154h14.786z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 22.25,
    r: 7.125,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00AC47",
    d: "M10.653 25.628a6.74 6.74 0 0 0 5.265 3.348l3.057-5.295-2.475-1.429-2.473 1.428-.825-1.428-.604-1.046-1.628-2.82a6.75 6.75 0 0 0-.318 7.242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4435",
    d: "M16.5 15.5a6.74 6.74 0 0 0-5.532 2.886l3.057 5.295 2.475-1.429v-2.856h6.112A6.75 6.75 0 0 0 16.5 15.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA00",
    d: "M22.347 25.628a6.74 6.74 0 0 0 .266-6.233H16.5v2.857l2.473 1.428-.825 1.429-.603 1.046-1.628 2.819a6.75 6.75 0 0 0 6.43-3.346"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.5 25.11a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.715"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M16.5 24.46a2.208 2.208 0 1 0 0-4.415 2.208 2.208 0 0 0 0 4.415"
  })));
};
export default SvgIcon2;